export const x = (...args: any[]) => {
  if (console && console.log) {
    console.log('>', ...args)
  }
}
